import httpClient from "@/services/httpClient";

export const sendAnswers = async (answers) => {
  const response = await httpClient.post("/api/v1/surveys/603/intro_survey_answers", {
    answers,
  });

  return response;
};
